The original criteria used to determine which events will be replayed.
